import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { CaseService } from '../../../shared/services/case.service';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { FormControl, FormGroup } from '@angular/forms';
import { EguardConfirmatialogComponent } from '../../../../core/components/confirm-dialog/confirm-dialog.component';
import { UserService } from '../../../shared/services/user.service';
import { PlaidService } from '../../../shared/services/plaid.service';
import { LocalUserService } from '../../../shared/services/localUser';
import { environment } from '../../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifyPopupComponent } from '../notify-popup/notify-popup.component';

@Component({
  selector: 'sevenOne',
  templateUrl: './sevenOne.component.html',
  styleUrls: ['./sevenOne.component.css'],
  providers: [
    PlaidService,
    LocalUserService
  ]
})
export class SevenOneComponent implements OnInit {
  case: string;
  form: string;
  temp: string;

  org: string;

  // component variables
  caseData: any = null;

  transactions = [];
  dueFormData: any;
  dueYear: any;
  dueMonth: any;

  // user
  token: string;
  userID: string;
  userRole: string;

  // confirm boxes
  dialogRef: any;

  displayedColumns: string[] = ['date_millisec', 'name', 'category', 'transaction_type', 'pending', 'amount'];

  loading = false;
  buttonLoading = false;
  banksLoading = true;

  accounts = [];

  // progress bar
  firstTimeload = true;
  progressValue = 0;
  progressStep = 0;
  /*
  indeterminate
  buffer
  query
  determinate
   */
  progressMode = 'buffer';
  progressMessage = 'Getting Accounts';

  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private caseService: CaseService,
    private cognito: CognitoUtil,
    private router: Router,
    private userService: UserService,
    private plaidService: PlaidService,
    private localUser: LocalUserService
  ) {
    this.case = this.route.snapshot.params['case'];
    this.form = this.route.snapshot.params['form'];
    this.temp = this.route.snapshot.params['id'];
  }

  ngOnInit() {
    this.userID = this.localUser.getUserId();
    this.userRole = this.localUser.getRole();
    this.org = this.localUser.getOrganizationId();
    this.getCase();
  }

  getCase() {
    this.caseService.getCaseById(this.org, this.case)
      .subscribe(result => {

        this.accounts = result.plaid_accounts;

        let dueForms = result.due_forms;

        for (let i = 0; i < dueForms.length; i++) {
          let dueForm = dueForms[i];

          if (dueForm.id === this.form) {
            this.dueFormData = dueForm;
          }
        }

        this.dueYear = new Date(this.dueFormData.due_date).getFullYear();
        this.dueMonth = new Date(this.dueFormData.due_date).getMonth() + 1;
        this.getTransactions();

      });
  }

  getTransactions() {
    this.transactions = [];
    this.updateSortingAccountsMessage(0, 0);

    let banks = 0;
    let accounts = 0;
    let accountInfo = [];

    if (this.accounts === null) {
      this.banksLoading = false;
    }
    else {
      for (let i = 0; i < this.accounts.length; i++) {
        banks++;
        this.updateSortingAccountsMessage(banks, accounts);
        for (let ii = 0; ii < this.accounts[i].accounts.length; ii++) {
          accounts++;
          accountInfo.push(this.accounts[i].accounts[ii]);
          this.updateSortingAccountsMessage(banks, accounts);
        }
      }

      this.progressStep = 100 / accounts;
      this.progressMode = 'determinate';
      this.progressValue = 0;

      this.getAccountsData(accountInfo);
    }
  }

  getAccountsData(accounts) {

    if (accounts.length === 0) {
      this.allAccountsRead();
      return;
    }

    let account = accounts[0];

    this.progressAccountMessage(account.name, account.mask);

    this.plaidService.getTransactionsByYear(this.dueYear, this.case, account.account_id)
      .subscribe(thisYearResult => {
        this.loadTransactionsIntoTable(thisYearResult);
        this.plaidService.getTransactionsByYear(this.dueYear - 1, this.case, accounts.account_id)
          .subscribe(lastYearResult => {
            this.loadTransactionsIntoTable(lastYearResult);
            this.progressValue += this.progressStep;
            this.getAccountsData(accounts.splice(1, accounts.length));
          });
      });

  }

  openCase() {
    this.router.navigate(['/case', this.org, this.case]);
  }

  loadTransactionsIntoTable(transactions) {

    if (transactions.length === 0) {
      return;
    }

    for (let i = 0; i < transactions.length; i++) {

      let transactionYear = new Date(transactions[i].date_millisec).getFullYear();
      let transactionMonth = new Date(transactions[i].date_millisec).getMonth() + 1;

      if ((transactionYear <= this.dueYear && transactionMonth <= this.dueMonth) || (transactionYear <= (this.dueYear - 1) && transactionMonth <= this.dueMonth)) {
        this.transactions.push(transactions[i]);
      }

    }

    this.transactions = this.transactions.sort(function (a, b) {
      return b.date_millisec - a.date_millisec;
    });

    return;
  }

  // this is not used yet. DO NOT DELETE
  editTransaction(id) {

  }

  // this is not used yet. DO NOT DELETE
  deleteTransaction(id) {
    let transaction = this.getTransaction(id);

    this.dialogRef = this.dialog.open(EguardConfirmatialogComponent, {
      data: {
        confirmMessage: 'You are about to delete this transaction.' +
          '\n\n' + this.formatDate(transaction.date_millisec) +
          '\n\n' + transaction.name +
          '\n\n$' + transaction.amount
      }
    });
    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.loading = true;
          /*this.plaidService.deleteTransaction(this.case, id, this.token)
              .subscribe( result => {
                this.reloadTransactions();
            });*/
          this.loading = false;
        }
      });

  }

  getStartDate() {
    return `${this.dueMonth}/1/${this.dueYear}`;
  }

  getEndDate() {
    return `${this.dueMonth}/1/${this.dueYear - 1}`;
  }

  getDateInMillisec(date) {
    return new Date(date).getTime();
  }

  submitSevenOne() {

    this.dialogRef = this.dialog.open(EguardConfirmatialogComponent, {
      data: {
        confirmMessage: 'You are about the submit these transactions to the court.'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.buttonLoading = true;

          let data = {
            start_date: this.getEndDate(),
            end_date: this.getStartDate(),
            form_id: '7.1'
          };

          this.caseService.postSevenOne(this.org, this.case, data)
            .subscribe(result => {

              let senddata = {
                form_id: this.form,
                petitionData: {},
                status: 'NEEDS_UPLOAD_FROM_GUARDIAN'
              };

              this.caseService.putDueForm(this.org, this.case, this.form, senddata)
                .subscribe(result => {
                  this.dialogRef = this.dialog.open(NotifyPopupComponent, {
                    data: {
                      title: 'Data Submission',
                      message: 'Your form will be made shortly.'
                    }
                  });
                  this.dialogRef.afterClosed()
                    .subscribe(response => {
                      this.router.navigate(['dashboard']);
                    });
                });

            });
        }
      });

  }

  formatDate(millisec) {
    let date = new Date(millisec);
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  }

  getTransaction(id) {
    for (let i = 0; i < this.transactions.length; i++) {
      if (this.transactions[i].transaction_id === id) {
        return this.transactions[i];
      }
    }
    return null;
  }

  getTransactionItemId(id) {
    return this.getTransaction(id).item_id;
  }

  allAccountsRead() {
    this.progressValue = 0;
    this.progressMode = 'buffer';
    this.progressMessage = 'All set loading tables';
    this.firstTimeload = false;
    this.loading = false;
  }

  transactionType(type) {
    switch (type) {
      case 'special':
      case 'digital':
        return 'Online';
      case 'place':
        return 'Store';
      default:
        return 'Other';
    }
  }

  updateSortingAccountsMessage(banks, accounts) {
    this.progressMessage = `Sorting accounts: ${banks} Banks / ${accounts} Accounts`;
    return;
  }

  progressAccountMessage(name, mask) {
    this.progressMessage = `Reading: ${name} ${mask}`;
    return;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/sevenOne/sevenOne.component.ts